
import { Emit } from "@/api/apiHelper";
import camelcaseKeys from "camelcase-keys";
import Vue from "vue";
import { Component } from "vue-property-decorator";
import DateFormatterMixin from "@/mixins/dateFormatterMixin";

@Component({
  mixins: [DateFormatterMixin],
})
export default class BotsOBTFuelEstimation extends Vue {
  // 📦 The estimated time in seconds in which the bots' OBT fuel will run out
  private estimatedBotFuelTimeInSeconds: number | null = null;

  protected mounted() {
    if (this.$store.state.subscription.currentSubscriptionPlan.isFeePerTrade) {
      Vue.prototype.$api
        .get("/api/v1/bot/estimateobtfee", null, Emit.None)
        .then((response: any) => {
          this.estimatedBotFuelTimeInSeconds = camelcaseKeys(
            response.data
          ).estimateDurationSec;
        });
    }
  }
}
